/* A1.4 — First Success Onboarding : premier deal → 360 → simulation → décision.
 * Progression calculée sur les jalons RÉELS (/ttv/summary), rien de décoratif. */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, Circle, Sparkles, X } from "lucide-react";

const STEPS = [
  { key: "first_deal", label: "Créer ou ouvrir un Deal", to: "/app/deals", hint: "Le Deal est l'objet maître de NOAM." },
  { key: "first_360", label: "Ouvrir sa fiche Deal 360", to: "/app/deals", hint: "Tout le contexte : phases, parties, documents, décisions." },
  { key: "first_simulation", label: "Simuler des scénarios (EV / AdjEV)", to: "/app/decisions", hint: "Sensitivity Lab : probabilités sourcées, seuils de bascule." },
  { key: "first_decision", label: "Prendre PURSUE / HOLD / PASS", to: "/app/decisions", hint: "Le verdict fige un snapshot immuable." },
];

export function FirstDecisionPath() {
  const [ms, setMs] = useState(null);
  const [decisionCount, setDecisionCount] = useState(0);
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem("noam_first_success_done") === "1"; } catch { return false; }
  });
  useEffect(() => {
    api.get("/workspace/ttv/summary").then((r) => { setMs(r.data.milestones); setDecisionCount(r.data.decision_count || 0); }).catch(() => {});
  }, []);
  if (dismissed || !ms) return null;
  const doneCount = STEPS.filter((s) => ms[s.key]).length;
  // W11 crédibilité — le bandeau de succès n'affirme JAMAIS sans réel serveur (≥1 décision existante)
  const allDone = !!ms.first_decision && decisionCount > 0;
  if (allDone) {
    return (
      <div className="noam-card p-4 border border-[#1D9E75]/40 bg-[#1D9E75]/5 flex items-start gap-3" data-testid="first-success-complete">
        <CheckCircle2 className="w-5 h-5 text-[#1D9E75] shrink-0 mt-0.5" />
        <div className="flex-1 text-sm text-zinc-200">
          <b>Votre première décision est maintenant enregistrée dans la mémoire de votre organisation.</b>
          <div className="text-xs text-zinc-400 mt-1">NOAM se souvient de ce que vous saviez, de ce que vous avez estimé et de pourquoi vous avez agi — et apprendra de ce qui se produira réellement.</div>
        </div>
        <button onClick={() => { try { localStorage.setItem("noam_first_success_done", "1"); } catch {} setDismissed(true); }}
          className="btn-ghost p-1" data-testid="first-success-dismiss"><X className="w-4 h-4" /></button>
      </div>
    );
  }
  return (
    <div className="noam-card p-4" data-testid="first-success-path">
      <div className="flex items-center gap-2 mb-2">
        <Sparkles className="w-4 h-4 text-[#EFD127]" />
        <span className="text-sm font-semibold text-zinc-100">Votre première décision en moins de 10 minutes</span>
        <span className="ml-auto text-[10px] text-zinc-500">{doneCount}/{STEPS.length}</span>
      </div>
      <div className="h-1 rounded bg-white/5 mb-3">
        <div className="h-1 rounded bg-[#EFD127] transition-all" style={{ width: `${(doneCount / STEPS.length) * 100}%` }} />
      </div>
      <div className="grid gap-1.5 sm:grid-cols-2">
        {STEPS.map((s) => {
          const done = !!ms[s.key];
          return (
            <Link key={s.key} to={s.to}
              className={`flex items-start gap-2 p-2 rounded text-xs transition-colors ${done ? "text-zinc-500" : "bg-white/[0.03] hover:bg-white/[0.06] text-zinc-200"}`}
              data-testid={`first-success-step-${s.key}`}>
              {done ? <CheckCircle2 className="w-3.5 h-3.5 text-[#1D9E75] shrink-0 mt-0.5" /> : <Circle className="w-3.5 h-3.5 text-zinc-600 shrink-0 mt-0.5" />}
              <span>
                <span className={done ? "line-through" : ""}>{s.label}</span>
                {!done && <span className="block text-[10px] text-zinc-500">{s.hint}</span>}
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
